import { Component } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent extends BaseComponent {}
